import { makePx } from "./px";
import { FONT } from "./label";
export var measure = function (ctx, _a) {
    var text = _a.text, _b = _a.labelSize, labelSize = _b === void 0 ? 12 : _b, _c = _a.font, font = _c === void 0 ? FONT : _c;
    var px = makePx(1);
    ctx.font = px(labelSize) + "px " + font;
    return ctx.measureText(text);
};
